export const appConstants = {
  conceptCode: "conceptCode",
  qrValue: "qrValue",
  surveyType: "surveyType",
  store: "Store",
  invoice: "Invoice",
  empty: "",
  language: "language",
  en: "en",
  ar: "ar",
  eng: "Eng",
  arb: "Arb",
  english: "English",
  arabic: "العربية",
  rtl: "rtl",
  ltr: "ltr",
  question: "question",
  wentWell: "wentWell",
  notWentWell: "notWentWell",
  likeProducts: "likeProducts",
  improveProducts: "improveProducts",
  likely: "likely",
  extremelyLikely: "extremelyLikely",
  thankyou: "thankyou",
  storeLength: 5,
  invoiceLength: 20,
  accessToken: "AccessToken",
  helpingUs: "helpingUs",
  android: "Android",
  ios: "iPhone",
  alreadyRated: "alreadyRated",
  shukranUrl: "https://shukran.com/ae/en/signin",
  AppStore: "https://apps.apple.com/us/app/id",
  PlayStore: "https://play.google.com/store/apps/details?id=com.landmarkgroup.",
  babyshopWeb: "https://babyshopstores.com/",
  shoeexpressWeb: "https://centrepointstores.com/",
  shoemartWeb: "https://centrepointstores.com/ae/en/brand/shoemart",
  centrepointWeb: "https://centrepointstores.com/",
  homeboxWeb: "https://homeboxstores.com/",
  splashWeb: "https://splashfashions.com/",
  shoemartinternationalWeb:
    "https://centrepointstores.com/ae/en/brand/shoemart",
  homecentreWeb: "https://homecentre.com/",
  lifestyleWeb: "https://centrepointstores.com/ae/en/brand/lifestyle/",
  maxWeb: "https://maxfashion.com/",
  detractors: "Detractors",
  passives: "Passives",
  promoters: "Promoters",
  territory: "ae",
  storeCode: "storeCode",
};
